
import React, { FC } from "react";
import { InputArea, InputContainer } from "./styles";
import { RadioButtonProps } from "./interface";

const RadioButtons: FC<RadioButtonProps> = ({
  getPreOrder,
  selectedRadio,
  setStatusViveo,
  setOrderStatus,
  getBionexoQuote,
  setStatusBionexo,
  setSelectedRadio,
  setOrderRadioSelected
}) => {

  const filterOrders = () => {
    setOrderRadioSelected(true);
    setSelectedRadio(1);
    setStatusBionexo([]);
    setStatusViveo([]);
    setOrderStatus(["CONFIRMED", "CANCELED"]);
    getPreOrder('', ["CONFIRMED", "CANCELED"], [], true);
  };

  const filterQuotations = () => {
    setOrderRadioSelected(false);
    setSelectedRadio(0);
    setStatusBionexo(["OPEN", "SENT", "UPDATED"]);
    setStatusViveo(["VALIDATE_PORTAL", "PENDING_MONEY", "ANSWERED_PORTAL"]);
    getBionexoQuote('', ["OPEN", "SENT", "UPDATED"], ["VALIDATE_PORTAL", "PENDING_MONEY", "ANSWERED_PORTAL"], [], true);
  };

  return (
    <InputArea>
      <InputContainer>
        <input
          type="radio"
          id="quotations"
          defaultChecked={selectedRadio === 0}
          value={selectedRadio}
          onClick={() => selectedRadio !== 0 && filterQuotations()}
          checked={selectedRadio !== 1}
        />
        <label htmlFor="quotations">Cotações</label>
      </InputContainer>

      <InputContainer>
        <input
          type="radio"
          id="orders"
          defaultChecked={selectedRadio === 1}
          value={selectedRadio}
          onClick={() => selectedRadio !== 1 && filterOrders()}
          checked={selectedRadio !== 0}
        />
        <label htmlFor="orders">Pedidos</label>
      </InputContainer>
    </InputArea>
  );
};

export default RadioButtons;